import { apiClient } from './api-client';

export const rootDependencies = {
  apiClient,
};
export type RootDependencies = typeof rootDependencies;
